import { render } from "./HeroSlider.vue?vue&type=template&id=b07b16a0&scoped=true"
import script from "./HeroSlider.vue?vue&type=script&lang=js"
export * from "./HeroSlider.vue?vue&type=script&lang=js"

import "./HeroSlider.vue?vue&type=style&index=0&id=b07b16a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b07b16a0"]])

export default __exports__